export function voyageLayout(screen, bounds = {}, mode = 'sailing') {
  const safe = { top: 0, right: 0, bottom: 0, left: 0, ...screen.safeArea };
  const available = { x: safe.left + 8, y: safe.top + 8,
    width: screen.width - safe.left - safe.right - 16, height: screen.height - safe.top - safe.bottom - 16 };
  const compact = Boolean(screen.isTouch) || screen.width < 600 || screen.height < 500;
  const landscape = compact && screen.width > screen.height && screen.width >= 600;
  const chartSize = landscape ? { width: 1040, height: 480 } : { width: 600, height: compact ? 740 : 710 };
  const chartScale = compact ? Math.min(available.width / chartSize.width, available.height / chartSize.height)
    : Math.min(350 / 600, available.height / 710);
  const chart = { x: compact ? available.x + (available.width - chartSize.width * chartScale) / 2
    : screen.width - safe.right - chartSize.width * chartScale - 16,
    y: compact ? available.y + (available.height - chartSize.height * chartScale) / 2 : Math.max(safe.top + 8, 82),
    width: chartSize.width * chartScale, height: chartSize.height * chartScale };
  const helmWidth = compact ? Math.min(available.width, landscape ? 1040 : 440) : 420;
  const helmScale = helmWidth / (landscape ? 1040 : 720);
  const controlHeight = compact ? Math.max(landscape ? 64 : 88, Math.ceil(44 / helmScale)) : 64;
  const helmSize = { width: landscape ? 1040 : 720,
    height: landscape ? mode === 'ashore' ? 164 : 218 : compact ? 92 + (controlHeight + 12) * (mode === 'ashore' ? 2 : 3) : 330 };
  const bottom = bounds.nav?.y ?? screen.height - safe.bottom - (compact ? 108 : 10);
  const helm = { x: compact ? available.x + (available.width - helmWidth) / 2 : safe.left + 16,
    y: bottom - helmSize.height * helmScale - 8, width: helmWidth, height: helmSize.height * helmScale };
  return { compact, landscape, chart, helm, chartSize, helmSize, controlHeight };
}

export function canvasButtonAt(rect, size, buttons, x, y) {
  if (!rect || x < rect.x || y < rect.y || x > rect.x + rect.width || y > rect.y + rect.height) return null;
  const px = (x - rect.x) / rect.width * size.width, py = (y - rect.y) / rect.height * size.height;
  return buttons.find(b => px >= b.x && px <= b.x + b.w && py >= b.y && py <= b.y + b.h) || { id: 'blank' };
}
